import { DIFFICULTY_LEVELS, QUESTION_TYPES } from '../questionTypes';

// 30 Preguntas del Músculo Glúteo Mayor
// 10 Básicas + 10 Generales + 10 Complejas

export const gluteoMayorQuestions = [
  
  // ========== NIVEL BÁSICO (10) ==========
  
  {
    id: 10151,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuál es la función principal del glúteo mayor?",
    options: [
      "Flexión de la cadera",
      "Extensión de la cadera",
      "Abducción de la cadera",
      "Rotación interna de la cadera"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor es el principal extensor de la cadera. Es el músculo más grande y potente del cuerpo humano, esencial para la marcha, carrera, subida de escaleras y mantenimiento de la posición erecta. Su fuerza es crucial para actividades diarias y deportivas."
  },
  
  {
    id: 10152,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Dónde se origina el glúteo mayor?",
    options: [
      "Ala del ilion, saco y cóccix",
      "Trocánter mayor del fémur",
      "Tuberosidad isquiática",
      "Línea áspera del fémur"
    ],
    correctAnswer: 0,
    explanation: "El glúteo mayor se origina en la cara glútea del ilion, la fascia toracolumbar, el sacro, el cóccix y el ligamento sacrotuberoso. Esta amplia inserción pélvica le proporciona una base sólida para su potente acción extensora."
  },
  
  {
    id: 10153,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Dónde se inserta el tendón del glúteo mayor?",
    options: [
      "Tuberosidad glútea del fémur",
      "Cóndilo femoral lateral",
      "Línea áspera del fémur",
      "Tubérculo del aductor"
    ],
    correctAnswer: 0,
    explanation: "El glúteo mayor se inserta en la tuberosidad glútea (tuberosidad cuadrada) del fémur, justo proximal al trocánter mayor. Esta inserción permite su acción como extensor y rotador externo de la cadera."
  },
  
  {
    id: 10154,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.INERVACION,
    question: "¿Qué nervio inerva al glúteo mayor?",
    options: [
      "Nervio glúteo inferior",
      "Nervio glúteo superior",
      "Nervio ciático",
      "Nervio femoral"
    ],
    correctAnswer: 0,
    explanation: "El nervio glúteo inferior (L5-S2) inerva al glúteo mayor. Este nervio emerge del foramen ciático mayor, inferior al músculo piriforme. La lesión del nervio glúteo inferior causa debilidad para extender la cadera y dificultad para subir escaleras."
  },
  
  {
    id: 10155,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué arteria irriga principalmente al glúteo mayor?",
    options: [
      "Arteria glútea superior",
      "Arteria glútea inferior",
      "Arteria femoral profunda",
      "Arteria obturatriz"
    ],
    correctAnswer: 1,
    explanation: "La arteria glútea inferior, rama de la arteria glútea interna, irriga principalmente al glúteo mayor. Esta arteria sale del foramen ciático mayor junto con el nervio glúteo inferior y proporciona irrigación a la porción inferior del músculo."
  },
  
  {
    id: 10156,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué estructura se encuentra profunda al glúteo mayor?",
    options: [
      "Glúteo medio",
      "Glúteo menor",
      "Piriforme y músculos rotadores",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Profundo al glúteo mayor se encuentran el glúteo medio, glúteo menor, piriforme y los músculos rotadores externos de la cadera. Esta disposición en capas permite movimientos complejos de la cadera y protección de estructuras más profundas."
  },
  
  {
    id: 10157,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Cuántas porciones funcionales tiene el glúteo mayor?",
    options: ["Una", "Dos", "Tres", "Cuatro"],
    correctAnswer: 1,
    explanation: "El glúteo mayor tiene dos porciones funcionales principales: superior (origina del ilion) y inferior (origina del sacro y cóccix). La porción superior es más horizontal y contribuye a la abducción, mientras que la inferior es más vertical y es el principal extensor."
  },
  
  {
    id: 10158,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.IDENTIFICACION,
    question: "¿Qué acción realiza el glúteo mayor en la rotación externa de la cadera?",
    options: [
      "Es el principal rotador externo",
      "Ayuda en la rotación externa",
      "No contribuye a la rotación externa",
      "Es rotador interno"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor contribuye a la rotación externa de la cadera, especialmente cuando la cadera está flexionada. Esta acción es importante en movimientos como patear un balón o caminar. Los rotadores externos profundos son los principales responsables."
  },
  
  {
    id: 10159,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el glúteo mayor es importante en la marcha?",
    options: [
      "Por su función de flexión",
      "Por su función de extensión durante el apoyo",
      "Por su función de abducción",
      "Por su función estética"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor es crucial en la marcha porque controla la extensión de la cadera durante la fase de apoyo (stance phase). Previene el colapso anterior de la pelvis y propulsa el cuerpo hacia adelante. Su debilidad causa la típica marcha de Trendelenburg."
  },
  
  {
    id: 10160,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.CONCEPTO,
    question: "¿Qué significa el término 'glúteo'?",
    options: [
      "Grande",
      "Redondo",
      "Posterior",
      "Elevado"
    ],
    correctAnswer: 0,
    explanation: "El término 'glúteo' proviene del griego 'gloutos' que significa 'nalga' o 'parte posterior'. El glúteo mayor es el músculo más grande del cuerpo humano, representando aproximadamente el 16-20% de la masa muscular total en individuos activos."
  },
  
  // ========== NIVEL GENERAL (10) ==========
  
  {
    id: 10161,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Cómo contribuye el glúteo mayor a la estabilidad pélvica?",
    options: [
      "Como flexor de la pelvis",
      "Como extensor y estabilizador posterior",
      "Como abductor de la pelvis",
      "No contribuye a la estabilidad"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor actúa como estabilizador posterior de la pelvis durante la bipedestación y marcha. Previene la anteversión pélvica excesiva y mantiene el equilibrio sagital. Su debilidad causa aumento de la lordosis lumbar compensatoria."
  },
  
  {
    id: 10162,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué músculos actúan como antagonistas del glúteo mayor?",
    options: [
      "Psoas iliaco y recto femoral",
      "Sartorio y tensor fascia lata",
      "Aductores de la cadera",
      "Todos los anteriores"
    ],
    correctAnswer: 3,
    explanation: "Los antagonistas del glúteo mayor son los flexores de cadera: psoas iliaco, recto femoral, sartorio, tensor fascia lata y aductores. Este equilibrio entre extensores y flexores es crucial para el control motor de la cadera."
  },
  
  {
    id: 10163,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VASCULARIZACION,
    question: "¿Qué rama específica de la arteria glútea inferior irriga el glúteo mayor?",
    options: [
      "Rama superficial",
      "Rama profunda",
      "Rama cutánea",
      "Rama muscular inferior"
    ],
    correctAnswer: 1,
    explanation: "La rama profunda de la arteria glútea inferior irriga la porción muscular profunda del glúteo mayor. Esta rama acompaña al nervio glúteo inferior y forma anastomosis importantes con las arterias glútea superior y femoral circunfleja medial."
  },
  
  {
    id: 10164,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.INERVACION,
    question: "¿De qué raíces nerviosas se origina el nervio glúteo inferior?",
    options: [
      "L4-L5",
      "L5-S1",
      "L5-S2",
      "S1-S3"
    ],
    correctAnswer: 2,
    explanation: "El nervio glúteo inferior se origina de las raíces L5-S2 del plexo sacro. Estas raíces emergen del foramen ciático mayor junto con la arteria glútea inferior. La lesión de estas raíces causa debilidad glútea y dificultad para subir escaleras."
  },
  
  {
    id: 10165,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VARIANTE,
    question: "¿Cuál es la variante anatómica más común del glúteo mayor?",
    options: [
      "Ausencia congénita",
      "Inserción doble en el fémur",
      "Fusión con glúteo medio",
      "Tendón accesorio"
    ],
    correctAnswer: 3,
    correctAnswer: 3,
    explanation: "La presencia de un tendón accesorio (fascículo separado que se inserta en la fascia lata o tracto iliotibial) es la variante más común del glúteo mayor, ocurriendo en 10-15% de la población. Puede confundirse con patología tendinosa."
  },
  
  {
    id: 10166,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué test evalúa específicamente la función del glúteo mayor?",
    options: [
      "Test de extensión resistida de cadera",
      "Test de Trendelenburg",
      "Test de Thomas",
      "Test de Ober"
    ],
    correctAnswer: 0,
    explanation: "El test de extensión resistida de cadera evalúa la fuerza del glúteo mayor. El paciente en prono extiende la cadera contra resistencia. Debilidad indica lesión del músculo o nervio glúteo inferior. Es más específico que pruebas funcionales como Trendelenburg."
  },
  
  {
    id: 10167,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.EMBRIOLOGIA,
    question: "¿De qué masa muscular embrionaria se desarrolla el glúteo mayor?",
    options: [
      "Masa glútea dorsal",
      "Masa flexora ventral",
      "Masa extensora dorsal",
      "Masa aductora medial"
    ],
    correctAnswer: 0,
    explanation: "El glúteo mayor se desarrolla de la masa muscular glútea dorsal del miembro inferior, alrededor de la 7-8 semana de gestación. Esta masa da origen también al glúteo medio y menor, explicando su inervación común por nervios glúteos."
  },
  
  {
    id: 10168,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.HISTOLOGIA,
    question: "¿Qué proporción aproximada de fibras musculares tiene el glúteo mayor?",
    options: [
      "90% fibras tipo I",
      "70% fibras tipo II",
      "50% tipo I, 50% tipo II",
      "30% tipo I, 70% tipo II"
    ],
    correctAnswer: 3,
    explanation: "El glúteo mayor tiene predominio de fibras tipo II (70%), adaptadas para movimientos potentes y explosivos. Sin embargo, tiene una proporción significativa de fibras tipo I (30%) para mantenimiento postural prolongado. Esta composición mixta refleja su doble función."
  },
  
  {
    id: 10169,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.RELACION,
    question: "¿Qué fascia cubre al glúteo mayor?",
    options: [
      "Fascia lata",
      "Fascia glútea",
      "Fascia toracolumbar",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor está cubierto por la fascia glútea, que es engrosada y forma el tracto iliotibial lateralmente. Esta fascia se continúa con la fascia toracolumbar y proporciona inserción a varias porciones del glúteo mayor."
  },
  
  {
    id: 10170,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.FUNCION,
    question: "¿Por qué el glúteo mayor es importante en la prevención de caídas en ancianos?",
    options: [
      "Por su función estética",
      "Por su función estabilizadora de la pelvis",
      "Por su función de propulsión",
      "Por su función de absorción de impacto"
    ],
    correctAnswer: 1,
    explanation: "El glúteo mayor es crucial para prevenir caídas en ancianos porque mantiene la estabilidad pélvica durante la marcha. Su debilidad (frecuente en sarcopenia) causa inestabilidad y aumenta el riesgo de caídas. El fortalecimiento del glúteo mayor reduce significativamente las caídas."
  },
  
  // ========== NIVEL COMPLEJO (10) ==========
  
  {
    id: 10171,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente con antecedente de inyección intramuscular en glúteo presenta parálisis del nervio ciático. ¿Qué complicación ocurrió?",
    options: [
      "Lesión del nervio glúteo superior",
      "Inyección en zona segura pero complicación",
      "Lesión del nervio glúteo inferior",
      "Inyección demasiado profunda"
    ],
    correctAnswer: 3,
    explanation: "La parálisis del nervio ciático por inyección intramuscular en glúteo indica inyección demasiado profunda que lesionó el nervio en el foramen ciático mayor. La zona segura para inyección en glúteo es el cuadrante superolateral. El nervio ciático es vulnerable cuando discurre entre piriforme y gemelo superior."
  },
  
  {
    id: 10172,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Paciente con dolor glúteo crónico y debilidad para extender cadera. EMG muestra denervación. ¿Qué nervio está afectado?",
    options: [
      "Nervio femoral",
      "Nervio ciático",
      "Nervio glúteo inferior",
      "Nervio obturador"
    ],
    correctAnswer: 2,
    explanation: "La combinación de dolor glúteo y debilidad para extender cadera con denervación en EMG indica lesión del nervio glúteo inferior. Este nervio puede comprimirse en el foramen ciático mayor o lesionarse en cirugías pélvicas. La prueba de Trendelenburg es positiva."
  },
  
  {
    id: 10173,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué abordaje se utiliza para reparar una ruptura completa del tendón del glúteo mayor?",
    options: [
      "Abordaje posterior longitudinal",
      "Abordaje lateral por el tracto iliotibial",
      "Abordaje anterior por el espacio intermuscular",
      "Abordaje endoscópico"
    ],
    correctAnswer: 0,
    explanation: "El abordaje posterior longitudinal permite acceso directo al tendón del glúteo mayor en la tuberosidad glútea. Las rupturas son raras pero ocurren en atletas de alto rendimiento. Se repara con anclas óseas o sutura transósea. La recuperación requiere inmovilización prolongada."
  },
  
  {
    id: 10174,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En RM de pelvis, ¿qué hallazgo confirma ruptura parcial del glúteo mayor?",
    options: [
      "Atrofia global del músculo",
      "Señal hiperintensa en T2 en la inserción femoral",
      "Engrosamiento tendinoso difuso",
      "Calcificaciones intratendinosas"
    ],
    correctAnswer: 1,
    explanation: "La ruptura parcial del glúteo mayor muestra señal hiperintensa en T2-STIR en la inserción femoral (tuberosidad glútea). Es más común en atletas de resistencia. La ecografía dinámica puede mostrar disrupción fibrilar durante contracción. La RM es superior para evaluar extensión de la lesión."
  },
  
  {
    id: 10175,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "¿Qué síndrome puede causar contractura del glúteo mayor?",
    options: [
      "Síndrome piriforme",
      "Síndrome del glúteo mayor",
      "Bursitis isquiática",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La contractura del glúteo mayor puede causar síndrome del glúteo mayor, caracterizado por dolor glúteo, limitación de la extensión de cadera y posible compresión del nervio ciático. Es común en corredores y ciclistas. Se trata con masaje, estiramiento y modificación de actividad."
  },
  
  {
    id: 10176,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CASO_CLINICO,
    question: "Paciente post-quirúrgico presenta 'marcha de Trendelenburg'. ¿Qué músculo está afectado?",
    options: [
      "Glúteo medio",
      "Glúteo mayor",
      "Tensor fascia lata",
      "Psoas iliaco"
    ],
    correctAnswer: 1,
    explanation: "La marcha de Trendelenburg (caída pélvica ipsilateral durante apoyo) indica debilidad del glúteo mayor o medio. La debilidad del glúteo mayor es más común post-cirugía pélvica o lesión del nervio glúteo inferior. Causa compensación contralateral con elevación pélvica."
  },
  
  {
    id: 10177,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.DIAGNOSTICO,
    question: "Evaluación isocinética muestra déficit selectivo de extensión concéntrica de cadera. ¿Qué está afectado?",
    options: [
      "Glúteo mayor únicamente",
      "Cadena extensora posterior",
      "Nervio glúteo inferior",
      "Todas las anteriores"
    ],
    correctAnswer: 2,
    explanation: "El déficit selectivo de extensión concéntrica de cadera en evaluación isocinética sugiere lesión del nervio glúteo inferior. El glúteo mayor es el principal extensor, pero la cadena extensora incluye también isquiotibiales y aductores. La isocinética cuantifica la fuerza específica."
  },
  
  {
    id: 10178,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.QUIRURGICA,
    question: "¿Qué técnica se utiliza para transferencia tendinosa en parálisis del glúteo mayor?",
    options: [
      "Transferencia del psoas iliaco",
      "Transferencia del dorsal ancho",
      "Transferencia del recto femoral",
      "Transferencia del tensor fascia lata"
    ],
    correctAnswer: 1,
    explanation: "La transferencia del tendón del dorsal ancho al trocánter mayor del fémur restaura la extensión de cadera en parálisis del glúteo mayor. El dorsal ancho se transfiere a través de un túnel óseo y se tensa para proporcionar extensión activa. Es una técnica reconstructiva compleja."
  },
  
  {
    id: 10179,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.IMAGENOLOGIA,
    question: "En ecografía del glúteo, ¿qué maniobra confirma bursitis isquiática?",
    options: [
      "Compresión directa de la tuberosidad isquiática",
      "Flexión de cadera con presión",
      "Abducción de cadera",
      "Rotación interna de cadera"
    ],
    correctAnswer: 0,
    explanation: "La ecografía con compresión directa de la tuberosidad isquiática reproduce dolor en bursitis isquiática. Se observa líquido en la bursa entre glúteo mayor e isquion. Es común en corredores y ciclistas. La bursitis isquiática puede confundirse con ciática."
  },
  
  {
    id: 10180,
    muscle: 'gluteo_mayor',
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.CORRELACION_CLINICA,
    question: "Atleta con hipertrofia compensatoria del glúteo mayor post-lesión de cuádriceps. ¿Qué explica esto?",
    options: [
      "Adaptación neural cruzada",
      "Sobrecarga funcional",
      "Efecto Wolff en hueso",
      "Todas las anteriores"
    ],
    correctAnswer: 1,
    explanation: "La hipertrofia compensatoria del glúteo mayor ocurre por sobrecarga funcional cuando el cuádriceps está debilitado. El glúteo mayor compensa la extensión de rodilla perdida, especialmente en atletas. Esto puede causar desequilibrios musculares y requiere rehabilitación equilibrada."
  }
];
